<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form inline size="small">
        <el-form-item label="关键词">
          <el-input
            v-model="listQuery.keyword"
            placeholder="酒店ID/编码/房型ID/产品ID/价格ID"
            clearable
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item label="模糊字段">
          <el-input
            v-model="listQuery.like_field"
            placeholder="指定单字段模糊查询"
            clearable
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item label="模糊值">
          <el-input
            v-model="listQuery.like_value"
            placeholder="模糊查询值"
            clearable
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item label="丽呈酒店ID">
          <el-input
            v-model="listQuery.hotel_id"
            placeholder="精确查询"
            clearable
            style="width: 130px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="丽呈房型ID">
          <el-input
            v-model="listQuery.roomtyp_id"
            placeholder="精确查询"
            clearable
            style="width: 130px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="丽呈产品ID">
          <el-input
            v-model="listQuery.product_id"
            placeholder="精确查询"
            clearable
            style="width: 130px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="丽呈价格ID">
          <el-input
            v-model="listQuery.rate_id"
            placeholder="精确查询"
            clearable
            style="width: 130px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 360px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <li-cheng-sync-button
            resource="product"
            label="同步指定酒店产品"
            @synced="getList"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      stripe
      size="small"
    >
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="API账号ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.api_account_id }}
        </template>
      </el-table-column>

      <el-table-column label="价格方案ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.price_plan_id }}
        </template>
      </el-table-column>

      <el-table-column label="丽呈酒店ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_id }}
        </template>
      </el-table-column>

      <el-table-column label="酒店编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_code }}
        </template>
      </el-table-column>

      <el-table-column label="房型ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.roomtyp_id }}
        </template>
      </el-table-column>

      <el-table-column label="产品ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.product_id }}
        </template>
      </el-table-column>

      <el-table-column label="价格ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.rate_id }}
        </template>
      </el-table-column>

      <el-table-column label="支付类型" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.payment_type === 1" type="success" size="mini">预付</el-tag>
          <el-tag v-else-if="scope.row.payment_type === 2" type="info" size="mini">现付</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="早餐数量" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.breakfast_cnt !== null ? scope.row.breakfast_cnt + '份' : '-' }}
        </template>
      </el-table-column>

      <el-table-column label="是否钟点房" min-width="90" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_hourly_room === 1" type="warning" size="mini">是</el-tag>
          <el-tag v-else-if="scope.row.is_hourly_room === 0" type="info" size="mini">否</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="同步时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.sync_at }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>

      <el-table-column label="其他" min-width="80" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.hourly_room_info || scope.row.raw_json">...</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleViewDetail(scope.row)"
          >
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 查看详情弹窗 -->
    <el-dialog
      title="产品详情"
      :visible.sync="dialogDetailVisible"
      width="700px"
      :close-on-click-modal="true"
    >
      <div class="detail-content">
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="丽呈酒店ID">
            {{ currentRow.hotel_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="酒店编码">
            {{ currentRow.hotel_code || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="房型ID">
            {{ currentRow.roomtyp_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="产品ID">
            {{ currentRow.product_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="价格ID">
            {{ currentRow.rate_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="支付类型">
            <el-tag v-if="currentRow.payment_type === 1" type="success" size="mini">预付</el-tag>
            <el-tag v-else-if="currentRow.payment_type === 2" type="info" size="mini">现付</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="早餐数量">
            {{ currentRow.breakfast_cnt !== null ? currentRow.breakfast_cnt + '份' : '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="是否钟点房">
            <el-tag v-if="currentRow.is_hourly_room === 1" type="warning" size="mini">是</el-tag>
            <el-tag v-else-if="currentRow.is_hourly_room === 0" type="info" size="mini">否</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="钟点房信息">
            {{ currentRow.hourly_room_info || '无' }}
          </el-descriptions-item>
        </el-descriptions>

        <div class="raw-json-section">
          <div class="raw-json-label">原始JSON：</div>
          <div v-if="currentRawJson" class="raw-json-content">
            <pre>{{ currentRawJson }}</pre>
          </div>
          <div v-else class="raw-json-empty">无原始数据</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      // 搜索参数
      listQuery: {
        page: 1,
        limit: 10,
        keyword: undefined,
        like_field: undefined,
        like_value: undefined,
        hotel_id: undefined,
        roomtyp_id: undefined,
        product_id: undefined,
        rate_id: undefined,
        start_at: undefined,
        end_at: undefined,
        sort: 'id',
        order: 'DESC',
      },
      // 日期范围
      dateRange: null,
      // 查看详情弹窗
      dialogDetailVisible: false,
      currentRow: {},
      currentRawJson: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    getList() {
      this.listLoading = true
      // 处理日期范围
      if (this.dateRange && this.dateRange.length === 2) {
        this.listQuery.start_at = this.dateRange[0]
        this.listQuery.end_at = this.dateRange[1]
      } else {
        this.listQuery.start_at = undefined
        this.listQuery.end_at = undefined
      }

      // 处理空值参数
      const params = {}
      Object.keys(this.listQuery).forEach((key) => {
        const val = this.listQuery[key]
        if (val !== '' && val !== undefined && val !== null) {
          params[key] = val
        }
      })

      request({
        url: '/api/backend/liCheng/hotel/productDetailList',
        method: 'get',
        params: params,
      })
        .then((response) => {
          this.list = response.data.items
          this.total = response.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 点击查询按钮
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    // 点击重置按钮
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        keyword: undefined,
        like_field: undefined,
        like_value: undefined,
        hotel_id: undefined,
        roomtyp_id: undefined,
        product_id: undefined,
        rate_id: undefined,
        start_at: undefined,
        end_at: undefined,
        sort: 'id',
        order: 'DESC',
      }
      this.dateRange = null
      this.getList()
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    // 当前页码变化
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    // 查看详情
    handleViewDetail(row) {
      this.currentRow = Object.assign({}, row)
      if (row.raw_json) {
        try {
          const parsed = JSON.parse(row.raw_json)
          this.currentRawJson = JSON.stringify(parsed, null, 2)
        } catch (e) {
          this.currentRawJson = row.raw_json
        }
      } else {
        this.currentRawJson = ''
      }
      this.dialogDetailVisible = true
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  margin-bottom: 10px;
}
.pagination-container {
  margin-top: 20px;
}
.detail-content {
  max-height: 500px;
  overflow: auto;
}
.raw-json-section {
  margin-top: 15px;
  .raw-json-label {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .raw-json-content {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    max-height: 200px;
    overflow: auto;
    pre {
      margin: 0;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-size: 12px;
      line-height: 1.5;
      color: #333;
    }
  }
  .raw-json-empty {
    text-align: center;
    padding: 20px;
    color: #999;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
}
</style>
